import FontHeading5 from '../../../../../../../components/fonts/font-heading5/font-heading5';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import CustomCollapsible from '../../ui/custom-collapsible/custom-collapsible';
import EligibilityBadges from '../../ui/eligibility-badges';
import { OrderEligibilityDisplayService, ItemEligibilityDto, PolicyEvaluation } from '../../order-eligibility-display.service';

import PolicyItemsList from './policy-items-list';

interface PolicyRuleCardProps {
    policy: PolicyEvaluation;
    items: ItemEligibilityDto[];
}

const PolicyRuleCard: React.FC<PolicyRuleCardProps> = ({ policy, items }) => {
    // Count eligible vs ineligible for this policy using service
    const { eligible: eligibleCount, ineligible: ineligibleCount } = 
        OrderEligibilityDisplayService.getPolicyEligibilityCounts(items, policy.policy_id);

    return (
        <CustomCollapsible
            key={policy.policy_id}
            title={
                <FontHeading5 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                    {policy.policy_name}
                </FontHeading5>
            }
            rightContent={
                <EligibilityBadges 
                    eligibleCount={eligibleCount}
                    ineligibleCount={ineligibleCount}
                />
            }
            isExpanded={false}
            level="primary"
        >
            <PolicyItemsList items={items} policy={policy} />
        </CustomCollapsible>
    );
};

export default PolicyRuleCard;
